import { type Address, parseAbi } from "viem";

const address = (value: string | undefined): Address | undefined => value?.match(/^0x[a-fA-F0-9]{40}$/) ? value as Address : undefined;

export const VALIDATOR_REGISTRY_ADDRESS = address(import.meta.env.VITE_VALIDATOR_REGISTRY_ADDRESS);
export const STAKE_VAULT_ADDRESS = address(import.meta.env.VITE_STAKE_VAULT_ADDRESS);
export const DISPUTE_RESOLUTION_ADDRESS = address(import.meta.env.VITE_DISPUTE_RESOLUTION_ADDRESS);
export const SCORE_ROOT_REGISTRY_ADDRESS = address(import.meta.env.VITE_SCORE_ROOT_REGISTRY_ADDRESS);
export const VERIFIED_LAUNCH_FACTORY_ADDRESS = address(import.meta.env.VITE_VERIFIED_LAUNCH_FACTORY_ADDRESS);
export const SERVICE_MARKETPLACE_ADDRESS = address(import.meta.env.VITE_SERVICE_MARKETPLACE_ADDRESS);
export const FEE_ROUTER_ADDRESS = address(import.meta.env.VITE_FEE_ROUTER_ADDRESS);
export const TRUST_COLLATERAL_TOKEN_ADDRESS = address(import.meta.env.VITE_TRUST_COLLATERAL_TOKEN_ADDRESS);

export const ERC20_APPROVAL_ABI = parseAbi([
  "function approve(address spender,uint256 amount) returns (bool)",
  "function decimals() view returns (uint8)",
  "function symbol() view returns (string)",
]);
export const VALIDATOR_REGISTRY_ABI = parseAbi([
  "function register(uint256 amount,string metadataURI)",
  "function increaseStake(uint256 amount)",
  "function requestExit()",
  "function withdraw()",
  "function minimumStake() view returns (uint256)",
  "function isActiveValidator(address account) view returns (bool)",
]);
export const SERVICE_MARKETPLACE_ABI = parseAbi([
  "function listService(uint256 agentId,address token,uint256 price,uint32 deliverySeconds,string metadataURI) returns (uint256)",
  "function setServiceActive(uint256 serviceId,bool active)",
  "function createOrder(uint256 serviceId,string requirementsURI) returns (uint256)",
  "function createOrderFromX402(uint256 serviceId,bytes32 evidenceId,string requirementsURI) returns (uint256)",
  "function deliver(uint256 orderId,string deliveryURI)",
  "function accept(uint256 orderId)",
  "function dispute(uint256 orderId,string evidenceURI)",
  "function claimTimeout(uint256 orderId)",
]);
export const VERIFIED_LAUNCH_FACTORY_ABI = parseAbi([
  "function createLaunch(uint256 projectId,address launchRecipient,address launchToken,uint256 launchAmount,address collateralToken,uint256 collateralAmount,uint64 releaseAt,string metadataURI) returns (uint256,address)",
  "function decide(uint256 launchId,bool approved,bytes32 evidenceHash)",
]);
export const SCORE_ROOT_REGISTRY_ABI = parseAbi([
  "function publish(bytes32 namespace,bytes32 root,bytes32 dimensionsHash,string schemaURI) returns (uint64)",
  "function latestVersion(bytes32 namespace) view returns (uint64)",
]);
export const STAKE_VAULT_ABI = parseAbi([
  "function createStake(bytes32 subject,bytes32 action,uint8 purpose,uint64 unlockAt,uint256 amount) returns (uint256)",
  "function increaseStake(uint256 positionId,uint256 amount)",
  "function withdraw(uint256 positionId)",
]);
export const DISPUTE_RESOLUTION_ABI = parseAbi([
  "function open(address respondent,address stakeVault,uint256 positionId,uint256 requestedSlash,string evidenceURI) returns (uint256)",
  "function rule(uint256 disputeId,uint8 ruling,string rationaleURI)",
  "function appeal(uint256 disputeId,string evidenceURI)",
  "function execute(uint256 disputeId)",
]);
